import { Actions } from "@ngrx/effects";
import { InstanceActionGroup } from "./state-utils/instanceActionGroup";
import { Blueprint } from "../cyanprints/blueprint";


export abstract class BlueprintEffectClass<TBlueprint extends Blueprint> {
  public  actions$: any;
  public actions: any;
  public instanceId: string;
  abstract instance: TBlueprint
}
